import {IEmployee} from "../../models/employee"
import {createSlice, PayloadAction} from "@reduxjs/toolkit"
import {IEmployeePayload} from "../../models/employee"
import {IValidationFieldErrorItem} from "../../models/validation"
import {AxiosError} from "axios"

interface IEmployeeState {
  list: IEmployee[]
  pages: number
  totalCount: number
  pageSize: number
  currentPage: number
  isLoading: boolean
  isCreating: boolean
  isUpdating: boolean
  error: any
  fetchError: string
}

const initialState: IEmployeeState = {
  list: [],
  pages: 0,
  totalCount: 0,
  pageSize: 10,
  currentPage: 1,
  isLoading: false,
  isCreating: false,
  isUpdating: false,
  error: "",
  fetchError: "",
}

type errorObject = {
  [key: string]: string
}

export const employeeSlice = createSlice({
  name: "employee",
  initialState,
  reducers: {
    fetching(state) {
      state.isLoading = true
    },
    fetchSuccess(state, action: PayloadAction<IEmployeePayload>) {
      state.isLoading = false
      state.fetchError = ""
      state.list = action.payload.list || []
      state.pages = action.payload.pages
      state.totalCount = action.payload.totalCount
    },
    fetchError(state, action: PayloadAction<AxiosError>) {
      state.isLoading = false

      if (action.payload.response?.status === 403) {
        state.fetchError = "У вас нет разрешения на эту операцию!"
      } else {
        state.fetchError = action.payload.message
      }
    },
    clear(state) {
      state.list = []
    },
    creating(state) {
      state.isCreating = true
    },
    createSuccess(state, action: PayloadAction<IEmployee>) {
      state.isCreating = false
    },
    creationError(state, action: PayloadAction<AxiosError>) {
      state.isCreating = false
    },
    updating(state) {
      state.isUpdating = true
    },
    updateSuccess(state) {
      state.isUpdating = false
    },
    updateError(state, action: PayloadAction<AxiosError>) {
      state.isUpdating = false
    },
    saveFieldError(state, action: PayloadAction<IValidationFieldErrorItem[]>) {
      state.isCreating = false
      state.isUpdating = false

      if (action.payload.length) {
        const obError: errorObject = {}
        state.error = action.payload.map(item => {
          return obError[item.field] = item.message
        })
        state.error = obError
      } else {
        state.error = action.payload
      }
    },
    clearFieldError(state, action: PayloadAction<string>) {
      delete state.error[action.payload]
    },
    clearAllErrors(state) {
      state.error = ""
    },
    setCurrentPage(state, action: PayloadAction<number>) {
      state.currentPage = action.payload
    }
  }
})

export default employeeSlice.reducer